import React from 'react';

/**
 * 단체(기업·기관) 디렉터리용 다인 상징 아이콘.
 * AllianceCardListContent.jsx IconPeople 과 동일 path (viewBox 0 0 14 14).
 */
export default function DirectoryOrgPeopleIcon({
  className = '',
  size = 14,
  stroke = 'currentColor',
  title,
  ...rest
}) {
  const pathProps = {
    stroke,
    strokeWidth: 1.16667,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
  };
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role={title ? 'img' : 'presentation'}
      aria-hidden={title ? undefined : true}
      aria-label={title}
      {...rest}
    >
      <path
        d="M9.33464 12.25V11.0833C9.33464 10.4645 9.0888 9.871 8.65122 9.43342C8.21363 8.99583 7.62014 8.75 7.0013 8.75H3.5013C2.88246 8.75 2.28897 8.99583 1.85139 9.43342C1.4138 9.871 1.16797 10.4645 1.16797 11.0833V12.25"
        {...pathProps}
      />
      <path
        d="M9.33203 1.82422C9.83239 1.95393 10.2755 2.24612 10.5918 2.65492C10.9082 3.06372 11.0798 3.56599 11.0798 4.08289C11.0798 4.59978 10.9082 5.10205 10.5918 5.51085C10.2755 5.91965 9.83239 6.21184 9.33203 6.34155"
        {...pathProps}
      />
      <path
        d="M12.832 12.2503V11.0837C12.8316 10.5667 12.6596 10.0645 12.3428 9.65586C12.0261 9.24726 11.5826 8.95542 11.082 8.82617"
        {...pathProps}
      />
      <path
        d="M5.2513 6.41667C6.53997 6.41667 7.58464 5.372 7.58464 4.08333C7.58464 2.79467 6.53997 1.75 5.2513 1.75C3.96264 1.75 2.91797 2.79467 2.91797 4.08333C2.91797 5.372 3.96264 6.41667 5.2513 6.41667Z"
        {...pathProps}
      />
    </svg>
  );
}
